export enum ROUTES_BASE {
  DASHBOARD = "/dashboard",
  COMPLIANCE = "/compliance",
  BUSINESSES = "/businesses",
  INDIVIDUALS = "/individuals",
  TRANSACTIONS = "/transactions",
  CREDIT = "/credit",
  REVENUE = "/revenue",
  SAVINGS = "/savings",
  REWARDS = "/rewards",
  REFERRAL_PROGRAM = "/referral-program",
  MARKETING = "/marketing",
  ON_DEMAND_SALARY = "/on-demand-salary",
  SUPPORT = "/support",
  SETTINGS = "/settings",
  AUDIT_LOGS = "/audit-logs",
  AUTH = "/auth",
  UI_COMPONENTS_DEMO = "/ui-components-demo",
  LANDING = "/",
}

export enum ROUTES {
  DASHBOARD_PAGE = ROUTES_BASE.DASHBOARD,
  COMPLIANCE_PAGE = ROUTES_BASE.COMPLIANCE,
  BUSINESSES_COMPLIANCE_PAGE = `${ROUTES_BASE.COMPLIANCE}/businesses`,
  BUSINESSES_COMPLIANCE_PAGE_READY_FOR_REVIEW = `${ROUTES_BASE.COMPLIANCE}/businesses/ready-for-review`,
  BUSINESSES_COMPLIANCE_PAGE_REJECTED = `${ROUTES_BASE.COMPLIANCE}/businesses/rejected`,
  INDIVIDUALS_COMPLIANCE_PAGE = `${ROUTES_BASE.COMPLIANCE}/individuals`,
  INDIVIDUALS_COMPLIANCE_PAGE_READY_FOR_REVIEW = `${ROUTES_BASE.COMPLIANCE}/individuals/ready-for-review`,
  INDIVIDUALS_COMPLIANCE_PAGE_REJECTED = `${ROUTES_BASE.COMPLIANCE}/individuals/rejected`,
  BUSINESSES_PAGE = `${ROUTES_BASE.BUSINESSES}/:activeStatus`,
  ADD_BUSINESSES_PAGE = `${ROUTES_BASE.BUSINESSES}/add-new-business`,
  UPDATE_BUSINESS_TYPE_PAGE = `${ROUTES_BASE.BUSINESSES}/update-business-type/:businessId`,
  CONTINUE_BUSINESS_REGISTRATION_PAGE = `${ROUTES_BASE.BUSINESSES}/business-registration/:businessId`,
  BUSINESS_DETAILS_PAGE = `${ROUTES_BASE.BUSINESSES}/details/:businessId`,
  BUSINESS_DETAILS_ACCOUNTS_PAGE = `${ROUTES_BASE.BUSINESSES}/accounts/:businessId`,
  BUSINESS_DETAILS_ACCOUNTS_TRANSACTIONS_PAGE = `${ROUTES_BASE.BUSINESSES}/accounts/:subAccountName/:walletId/transactions`,
  BUSINESS_DETAILS_TRANSACTIONS_PAGE = `${ROUTES_BASE.BUSINESSES}/transactions/:businessId`,
  BUSINESS_DETAILS_YIELD_PAGE = `${ROUTES_BASE.BUSINESSES}/yield/:businessId`,
  BUSINESS_DETAILS_ADMINS_PAGE = `${ROUTES_BASE.BUSINESSES}/admins/:businessId`,
  BUSINESS_DETAILS_EMPLOYEES_PAGE = `${ROUTES_BASE.BUSINESSES}/employees/:businessId`,
  BUSINESS_DETAILS_ODP_PAGE = `${ROUTES_BASE.BUSINESSES}/odp/:businessId`,
  BUSINESS_DETAILS_PAYROLL_PAGE = `${ROUTES_BASE.BUSINESSES}/payroll/:businessId`,
  BUSINESS_TRANSACTION_LIMIT_PAGE = `${ROUTES_BASE.BUSINESSES}/details/:businessId/transaction-limit`,
  INDIVIDUALS_PAGE = ROUTES_BASE.INDIVIDUALS,
  INDIVIDUALS_DETAILS_PAGE = `${ROUTES_BASE.INDIVIDUALS}/details/:individualId`,
  INDIVIDUALS_ACCOUNT_DETAILS_PAGE = `${ROUTES_BASE.INDIVIDUALS}/account/:individualId`,
  INDIVIDUALS_ACCOUNT_TRANSACTION_DETAILS_PAGE = `${ROUTES_BASE.INDIVIDUALS}/account/:accountName/:individualId/view-transactions/:walletId`,
  INDIVIDUALS_ACCOUNT_VIEW_TRANSACTION_DETAILS_PAGE = `${ROUTES_BASE.INDIVIDUALS}/account/:transactionId/view-transaction-details`,
  INDIVIDUALS_TRANSACTIONS_DETAILS_PAGE = `${ROUTES_BASE.INDIVIDUALS}/transactions/:individualId`,
  INDIVIDUALS_TRANSACTION_VIEW_TRANSACTION_DETAILS_PAGE = `${ROUTES_BASE.INDIVIDUALS}/transactions/:individualId/view-transaction-details`,
  INDIVIDUALS_LOANS_DETAILS_PAGE = `${ROUTES_BASE.INDIVIDUALS}/loans/:individualId`,
  INDIVIDUALS_SAVINGS_DETAILS_PAGE = `${ROUTES_BASE.INDIVIDUALS}/savings/:individualId`,
  INDIVIDUALS_ON_DEMAND_PAY_DETAILS_PAGE = `${ROUTES_BASE.INDIVIDUALS}/on-demand-pay/:individualId`,
  INDIVIDUAL_VIEW_LOAN_DETAILS_PAGE = `${ROUTES_BASE.INDIVIDUALS}/loans/:loanId/:userId/view-loan-details`,
  INDIVIDUAL_VIEW_SAVING_DETAILS_PAGE = `${ROUTES_BASE.INDIVIDUALS}/savings/:id/:savingsType/view-saving-details`,
  INDIVIDUAL_VIEW_SAVINGS_HISTORY_PAGE = `${ROUTES_BASE.INDIVIDUALS}/savings/:id/:savingsType/view-savings-history`,
  INDIVIDUAL_VIEW_WITHDRAWAL_HISTORY_PAGE = `${ROUTES_BASE.INDIVIDUALS}/on-demand-pay/:employeeId/:accountName/view-withdrawal-history/:withdrawal/:fee`,
  TRANSACTIONS_DETAILS_PAGE = `${ROUTES_BASE.TRANSACTIONS}/details/:transactionId`,
  TRANSACTIONS_ODP_DETAILS_PAGE = `${ROUTES_BASE.TRANSACTIONS}/on-demand-pay/details/:transactionId`,
  TRANSACTION_DETAILS_PAGE = `${ROUTES_BASE.TRANSACTIONS}/details/:transactionRef/:transactionType`,
  TRANSACTIONS_PAGE_ALL = `${ROUTES_BASE.TRANSACTIONS}/all/:transactionType`,
  INDIVIDUALS_TRANSACTIONS_PAGE = `${ROUTES_BASE.TRANSACTIONS}/individuals/:transactionType`,
  BUSINESSES_TRANSACTIONS_PAGE = `${ROUTES_BASE.TRANSACTIONS}/businesses/:transactionType`,
  CREDIT_PAGE = ROUTES_BASE.CREDIT,
  REVENUE_PAGE = ROUTES_BASE.REVENUE,
  SAVINGS_PAGE = ROUTES_BASE.SAVINGS,
  INDIVIDUALS_SAVINGS_PAGE = `${ROUTES_BASE.SAVINGS}/individuals/:savingsType`,
  INDIVIDUALS_FLEX_SAVINGS_PAGE = `${ROUTES_BASE.SAVINGS}/individuals/flex-savings`,
  INDIVIDUALS_FLEX_SAVINGS_VIEW_DETAILS_PAGE = `${ROUTES_BASE.SAVINGS}/individuals/flex-savings/:id/view-savings-details`,
  INDIVIDUALS_FLEX_SAVINGS_VIEW_HISTORY_PAGE = `${ROUTES_BASE.SAVINGS}/individuals/flex-savings/:id/view-savings-history`,
  INDIVIDUALS_GOAL_SAVINGS_PAGE = `${ROUTES_BASE.SAVINGS}/individuals/goal-savings`,
  INDIVIDUALS_GOAL_SAVINGS_VIEW_DETAILS_PAGE = `${ROUTES_BASE.SAVINGS}/individuals/goal-savings/:id/view-savings-details`,
  INDIVIDUALS_GOAL_SAVINGS_VIEW_HISTORY_PAGE = `${ROUTES_BASE.SAVINGS}/individuals/goal-savings/:id/view-savings-history`,
  INDIVIDUALS_VAULT_SAVINGS_PAGE = `${ROUTES_BASE.SAVINGS}/individuals/vault-savings`,
  INDIVIDUALS_VAULT_SAVINGS_VIEW_DETAILS_PAGE = `${ROUTES_BASE.SAVINGS}/individuals/vault-savings/:id/view-savings-details`,
  INDIVIDUALS_VAULT_SAVINGS_VIEW_HISTORY_PAGE = `${ROUTES_BASE.SAVINGS}/individuals/vault-savings/:id/view-savings-history`,
  BUSINESSES_SAVINGS_PAGE = `${ROUTES_BASE.SAVINGS}/businesses/:savingsType`,
  BUSINESSES_VAULT_SAVINGS_DETAILS_PAGE = `${ROUTES_BASE.SAVINGS}/businesses/vault-savings/details/:id`,
  BUSINESSES_FIXED_DEPOSITS_DETAILS_PAGE = `${ROUTES_BASE.SAVINGS}/businesses/fixed-deposits/details/:id`,
  BUSINESSES_VAULT_SAVINGS_HISTORY_PAGE = `${ROUTES_BASE.SAVINGS}/businesses/vault-savings/history/:id`,
  BUSINESSES_FIXED_DEPOSITS_HISTORY_PAGE = `${ROUTES_BASE.SAVINGS}/businesses/fixed-deposits/history/:id`,
  REWARDS_PAGE = ROUTES_BASE.REWARDS,
  REFERRAL_PROGRAM_PAGE = ROUTES_BASE.REFERRAL_PROGRAM,
  MARKETING_PAGE = ROUTES_BASE.MARKETING,
  ON_DEMAND_SALARY_PAGE = ROUTES_BASE.ON_DEMAND_SALARY,
  SUPPORT_PAGE = ROUTES_BASE.SUPPORT,
  SETTINGS_PAGE = ROUTES_BASE.SETTINGS,
  AUDIT_LOGS_PAGE = ROUTES_BASE.AUDIT_LOGS,
  CREATE_PASSWORD_PAGE = `${ROUTES_BASE.AUTH}/create-new-password`,
  FORGOT_PASSWORD_PAGE = `${ROUTES_BASE.AUTH}/forgot-password`,
  LOGIN_PAGE = `${ROUTES_BASE.AUTH}/login`,
  VERIFY_PASSWORD_PAGE = `${ROUTES_BASE.AUTH}/verify-password`,
  UI_COMPONENTS_DEMO_PAGE = ROUTES_BASE.UI_COMPONENTS_DEMO,
  UI_COMPONENTS_DEMO_APPROVED_PAGE = `${ROUTES.UI_COMPONENTS_DEMO_PAGE}/approved`,
  UI_COMPONENTS_DEMO_REJECTED_PAGE = `${ROUTES.UI_COMPONENTS_DEMO_PAGE}/rejected`,
  LANDING_PAGE = ROUTES_BASE.LANDING,
  INDIVIDUAL_TRANSACTIONS_DETAILS_PAGE = `${ROUTES_BASE.TRANSACTIONS}/individuals/details/:individualId`,
  NOT_FOUND_PAGE = "/404",
}
